/**
 * Scalysis: force cart "Check out" through Masum checkout (same as Buy it now).
 * Theme-level fix for Route of Dreams.
 */
(function () {
  "use strict";
  if (window.__scalysisCartCheckoutFix) return;
  window.__scalysisCartCheckoutFix = true;

  var APP_FALLBACK = "https://checkout.135-235-216-75.nip.io";
  var BTN_BG = "#00003E";
  var BTN_FG = "#ffffff";
  var BTN_RADIUS = "8px";

  function appUrl() {
    var raw = (window.unskwikConfig && window.unskwikConfig.appUrl) || APP_FALLBACK;
    return String(raw).trim().replace(/\/+$/, "");
  }

  function labelOf(el) {
    return String(
      (el && (el.textContent || el.value || (el.getAttribute && el.getAttribute("aria-label")))) ||
        "",
    )
      .replace(/\s+/g, " ")
      .trim()
      .toLowerCase();
  }

  function isAddToCart(el) {
    if (!el) return false;
    var name = String((el.getAttribute && el.getAttribute("name")) || "").toLowerCase();
    var label = labelOf(el);
    var form = el.closest && el.closest("form");
    var action = String((form && (form.getAttribute("action") || form.action)) || "").toLowerCase();
    if (name === "add" && (label.indexOf("add to cart") !== -1 || label === "add")) return true;
    if (
      action.indexOf("/cart/add") !== -1 &&
      label.indexOf("buy it now") === -1 &&
      label.indexOf("buy now") === -1
    ) {
      return true;
    }
    if (label.indexOf("add to cart") !== -1 || label === "add to bag" || label === "add to basket") {
      return true;
    }
    return false;
  }

  function isCheckoutTrigger(el) {
    if (!el || isAddToCart(el)) return false;
    var tag = String(el.tagName || "").toLowerCase();
    var name = String((el.getAttribute && el.getAttribute("name")) || "").toLowerCase();
    var href = String((el.getAttribute && el.getAttribute("href")) || "").toLowerCase();
    var label = labelOf(el);
    if (name === "checkout") return true;
    if (tag === "a" && href.indexOf("/checkout") !== -1) return true;
    if (label.indexOf("buy it now") !== -1 || label === "buy now") return true;
    if (label === "check out" || label === "checkout" || label.indexOf("proceed to checkout") !== -1) {
      return true;
    }
    if (
      el.matches &&
      el.matches(".cart__checkout-button, .cart-checkout, .checkout-button, #checkout, [data-checkout]")
    ) {
      return true;
    }
    return false;
  }

  function isCartForm(form) {
    if (!form) return false;
    var action = String(form.getAttribute("action") || form.action || "").toLowerCase();
    if (!action || action.indexOf("/cart/add") !== -1) return false;
    try {
      var path = new URL(action, window.location.origin).pathname.replace(/\/+$/, "");
      return path === "/cart" || path.slice(-5) === "/cart";
    } catch (e) {
      return /\/cart\/?(?:\?|$)/.test(action);
    }
  }

  function getCart() {
    return fetch("/cart.js")
      .then(function (r) {
        return r.json();
      })
      .catch(function () {
        return {};
      });
  }

  function showModal(cartData) {
    var existing = document.getElementById("unskwik-modal-overlay");
    if (existing) existing.remove();

    var shopDomain =
      (window.unskwikConfig && window.unskwikConfig.shop) ||
      (window.Shopify && window.Shopify.shop) ||
      window.location.hostname.replace(".myshopify.com", "") ||
      "";

    var compactCart = {
      currency: (cartData && cartData.currency) || "INR",
      items: Array.isArray(cartData && cartData.items)
        ? cartData.items.map(function (item) {
            return {
              id: item.variant_id || item.id,
              variantId: item.variant_id || item.id,
              key: item.key,
              title: item.product_title || item.title || "",
              variantTitle: item.variant_title || "",
              sku: item.sku || "",
              quantity: item.quantity || 1,
              linePrice:
                item.final_line_price != null ? item.final_line_price : item.line_price || 0,
              image: (item.featured_image && item.featured_image.url) || item.image || null,
            };
          })
        : [],
    };

    var fingerprint = compactCart.items
      .map(function (item) {
        return (item.variantId || item.id) + ":" + item.quantity;
      })
      .sort()
      .join("|");

    var params = new URLSearchParams();
    if (shopDomain) params.set("shop", shopDomain);
    params.set("cart", JSON.stringify(compactCart));
    if (fingerprint) params.set("cartFingerprint", fingerprint);

    var overlay = document.createElement("div");
    overlay.id = "unskwik-modal-overlay";
    overlay.style.cssText =
      "position:fixed;inset:0;z-index:2147483646;background:rgba(0,0,0,.45);";
    var modal = document.createElement("div");
    modal.id = "unskwik-modal-content";
    modal.style.cssText = "position:fixed;inset:0;z-index:2147483647;background:#fff;";
    var iframe = document.createElement("iframe");
    iframe.src = appUrl() + "/checkout/modal?" + params.toString();
    iframe.setAttribute(
      "sandbox",
      "allow-scripts allow-same-origin allow-forms allow-popups allow-popups-to-escape-sandbox",
    );
    iframe.setAttribute(
      "allow",
      "otp-credentials *; publickey-credentials-get *; clipboard-read; clipboard-write; geolocation",
    );
    iframe.style.cssText = "width:100%;height:100%;border:0;";
    modal.appendChild(iframe);
    overlay.appendChild(modal);
    document.body.appendChild(overlay);
    document.body.style.overflow = "hidden";

    function close() {
      overlay.remove();
      document.body.style.overflow = "";
      window.removeEventListener("message", onMsg);
    }
    function onMsg(event) {
      var data = event && event.data;
      if (!data) return;
      if (data.type === "unskwik-close-modal" || data.type === "scalysis-close-modal") close();
      if (data.type === "unskwik-redirect-checkout" && data.checkoutUrl) {
        window.location.href = data.checkoutUrl;
      }
    }
    window.addEventListener("message", onMsg);
  }

  function openCheckout(el) {
    var form = el && el.closest && el.closest("form");
    var label = labelOf(el);
    var isBuyNow = label.indexOf("buy it now") !== -1 || label === "buy now";
    if (isBuyNow && form) {
      var fd = new FormData(form);
      fetch(form.action, { method: "POST", body: fd })
        .then(function () {
          return getCart();
        })
        .then(showModal)
        .catch(function () {
          showModal({});
        });
      return;
    }
    getCart()
      .then(showModal)
      .catch(function () {
        showModal({});
      });
  }

  function styleCartButtons() {
    document
      .querySelectorAll(
        'button.cart__checkout-button, button[name="checkout"], #checkout, #cart-notification-form button[name="checkout"]',
      )
      .forEach(function (btn) {
        if (!isCheckoutTrigger(btn)) return;
        btn.style.setProperty("background-color", BTN_BG, "important");
        btn.style.setProperty("background", BTN_BG, "important");
        btn.style.setProperty("color", BTN_FG, "important");
        btn.style.setProperty("border", "0", "important");
        btn.style.setProperty("border-radius", BTN_RADIUS, "important");
        btn.style.setProperty("display", "inline-flex", "important");
        btn.style.setProperty("align-items", "center", "important");
        btn.style.setProperty("justify-content", "center", "important");
        btn.style.setProperty("width", "100%", "important");
      });
  }

  document.addEventListener(
    "click",
    function (e) {
      var el =
        e.target &&
        e.target.closest &&
        e.target.closest(
          'button, a, input[type="submit"], [name="checkout"], .cart__checkout-button, [data-checkout]',
        );
      if (!el || !isCheckoutTrigger(el)) return;
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      openCheckout(el);
      return false;
    },
    true,
  );

  document.addEventListener(
    "submit",
    function (e) {
      var form = e.target;
      if (!form || form.tagName !== "FORM") return;
      var submitter = e.submitter;
      var checkoutIntent = false;
      if (isCartForm(form)) {
        var name = String(
          (submitter && submitter.getAttribute && submitter.getAttribute("name")) || "",
        ).toLowerCase();
        var label = labelOf(submitter);
        checkoutIntent =
          name === "checkout" ||
          label === "check out" ||
          label === "checkout" ||
          label.indexOf("proceed to checkout") !== -1 ||
          (submitter &&
            submitter.matches &&
            submitter.matches(".cart__checkout-button, [data-checkout]"));
      } else if (submitter && isCheckoutTrigger(submitter)) {
        checkoutIntent = true;
      } else if (
        String(form.getAttribute("action") || form.action || "")
          .toLowerCase()
          .indexOf("/checkout") !== -1
      ) {
        checkoutIntent = true;
      }
      if (!checkoutIntent) return;
      if (submitter && isAddToCart(submitter) && !isCheckoutTrigger(submitter)) return;
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      openCheckout(submitter || form);
      return false;
    },
    true,
  );

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", styleCartButtons);
  } else {
    styleCartButtons();
  }
  new MutationObserver(styleCartButtons).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
